export default "__VITE_ASSET__45fbb3d4__"